import { Component, OnInit, PLATFORM_ID, Inject, Renderer2 } from '@angular/core';
import { isPlatformBrowser, DOCUMENT } from '@angular/common';
import { Title, Meta } from '@angular/platform-browser';
import * as $ from 'jquery';
import { LinkService } from '../../../_services/langhfre.service';
import { LoadScriptService } from 'src/app/_services/load-script.service';
import { NavigationService } from 'src/app/_services/navigation.service';
//declare function ire(string,{}): any;
@Component({
  selector: 'app-inclusive-language-report',
  templateUrl: './inclusive-language-report.component.html',
  styleUrls: ['./inclusive-language-report.component.scss']
})
export class InclusiveLanguageReportComponent implements OnInit {
  
  lqr_Correctness: boolean = false;
  lqr_Readability: boolean = false;
  lqr_Consistency: boolean = false;
  lqr_Conciseness: boolean = false;
  lqr_FormalTone: boolean = false;
  lqr_InclusiveLanguage: boolean = false;
  lqr_CodeWords: boolean = false;
  lqr_GenderCode: boolean = true;
  status: boolean = false;
  
  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    private LinkService: LinkService,
    @Inject(PLATFORM_ID) private platformId: Object,
    private _renderer2: Renderer2,
    @Inject(DOCUMENT) private _document: Document,
    public loadScript: LoadScriptService,
    public navigationService: NavigationService
  ) {
   }

  ngOnInit(): void {
    this.titleService.setTitle(' Inclusive Language Check | Make Your Communication Bias Free ');
    this.metaTagService.updateTag({ name: 'description', content: " Make your writing inclusive and enhance audience engagement with our expert tips. Elevate your DEIB (Diversity, Equity, Inclusion, and Belonging) goals with impactful writing strategies." });
    this.metaTagService.updateTag({ property: 'og:title', content: ' Inclusive Language Check | Make Your Communication Bias Free ' });
    this.metaTagService.updateTag({ property: 'og:description', content: ' Make your writing inclusive and enhance audience engagement with our expert tips. Elevate your DEIB (Diversity, Equity, Inclusion, and Belonging) goals with impactful writing strategies.' });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/features/inclusive-language-check' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ property: 'og:image', content: 'https://www.trinka.ai/assets/images/bias-banner.svg' });
    this.metaTagService.updateTag({ name: 'language', content: 'en-us' });
    this.metaTagService.updateTag({ name: 'twitter:title', content: ' Inclusive Language Check | Make Your Communication Bias Free' });
    this.metaTagService.updateTag({ name: 'twitter:description', content: " Make your writing inclusive and enhance audience engagement with our expert tips. Elevate your DEIB (Diversity, Equity, Inclusion, and Belonging) goals with impactful writing strategies." });
    this.metaTagService.updateTag({ name: 'twitter:image', content: 'https://www.trinka.ai/assets/images/bias-banner.svg' });
    this.metaTagService.updateTag({ name: 'keywords', content: 'inclusive language checker, Microsoft Word Inclusivity Checker, best inclusive language tool, Inclusive Language Checker, Inclusive language checker online, Inclusive language checker free, microsoft word inclusive language checker, bias language checker, gender-inclusive language examples' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/features/inclusive-language-check' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/features/inclusive-language-check' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/features/inclusive-language-check' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/features/inclusive-language-check' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/features/inclusive-language-check' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/features/inclusive-language-check' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/features/inclusive-language-check' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/features/inclusive-language-check' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/features/inclusive-language-check' });
    if (isPlatformBrowser(this.platformId)) {
      // $.getScript('../../../assets/js/particles.min.js', function(){});
      $.getScript('../../../../assets/js/wisepop.js', function () { });
    }
    let script = this._renderer2.createElement('script');
    script.type = `application/ld+json`;
    script.text = `
    {"@context":"https://schema.org","@graph":[{"@type":"Product","name":"Inclusive Language Check","image":"https://www.trinka.ai/assets/images/bias-banner.svg","description":"Make your writing inclusive and enhance audience engagement with our expert tips. Elevate your DEIB (Diversity, Equity, Inclusion, and Belonging) goals with impactful writing strategies.","brand":{"@type":"Brand","name":"Trinka AI"},"offers":{"@type":"Offer","url":"https://www.trinka.ai/pricing","priceCurrency":"USD","price":"0","priceValidUntil":"2030-12-31","availability":"InStock","hasMerchantReturnPolicy":{"@type":"MerchantReturnPolicy","url":"https://www.trinka.ai/termsofservices","returnPolicyCategory":"https://schema.org/MerchantReturnNotPermitted","applicableCountry":"GL"},"shippingDetails":{"@type":"OfferShippingDetails","shippingDestination":{"@type":"DefinedRegion","addressCountry":"ALL"},"shippingRate":{"@type":"MonetaryAmount","value":"0","currency":"USD"},"deliveryTime":{"@type":"ShippingDeliveryTime","handlingTime":{"@type":"QuantitativeValue","minValue":1,"maxValue":1,"unitCode":"d"},"transitTime":{"@type":"QuantitativeValue","minValue":1,"maxValue":1,"unitCode":"d"}}}},"aggregateRating":{"@type":"AggregateRating","ratingValue":"4.8","reviewCount":"78"},"review":{"@type":"Review","author":{"@type":"Person","name":"Jesse Rumball-Smith"},"reviewRating":{"@type":"Rating","ratingValue":"5","bestRating":"5"},"reviewBody":"I just wanted to say thank you for such a great and free service. Unlike other writing assistants, Trinka offers exceptional features even on the free subscription plan. As a student with limited income, I am extremely grateful for this fantastic product. I've let all my fellow students know about Trinka as it is seriously a lifesaver."}},{"@type":"FAQPage","mainEntity":[{"@type":"Question","name":"What is Trinka AI's Inclusive Language Check?","acceptedAnswer":{"@type":"Answer","text":"Trinka AI's Inclusive Language Check is an advanced tool that helps you identify and eliminate potential biases in your writing. It analyzes your content for six key categories of bias: gender, race, age, religion, disability, and sexual orientation and identity."}},{"@type":"Question","name":"How does Trinka AI's Inclusive Language Check work?","acceptedAnswer":{"@type":"Answer","text":"Trinka AI's Inclusive Language Check uses sophisticated natural language processing (NLP) algorithms to identify patterns and language indicators that may suggest potential biases. It then provides suggestions for how to rephrase your language to be more inclusive and respectful."}}]},{"@type":"BreadcrumbList","itemListElement":[{"@type":"ListItem","position":1,"name":"Trinka AI","item":"https://www.trinka.ai"},{"@type":"ListItem","position":2,"name":"Features","item":"https://www.trinka.ai/features/"},{"@type":"ListItem","position":3,"name":"Inclusive Language Check","item":"https://www.trinka.ai/features/inclusive-language-check"}]},{"@type":"SoftwareApplication","name":"Inclusive Language Check","operatingSystem":"Web-based","applicationCategory":"Writing Tools","aggregateRating":{"@type":"AggregateRating","ratingValue":"4.8","reviewCount":"189"},"offers":{"@type":"Offer","price":"0","priceCurrency":"USD","availability":"Online","url":"https://www.trinka.ai/features/inclusive-language-check"}}]}
    `;
    this._renderer2.appendChild(this._document.head, script);

    //ire('identify', { 'customerId': '', customerEmail: '', customProfileId: '' });
  }

  scroll(el: HTMLElement) {
    el.scrollIntoView({ behavior: 'smooth' });
  }
  ngAfterViewInit() {
    if (isPlatformBrowser(this.platformId)) {
      $('#closedPopup, #wordPluginPopup').click(function () {
        $('iframe.youtubeVideoForTryDemo').remove()
      });

      $('#VewiVideoSection').click(function () {
        if (!$('#iframe').length) {
          $('#iframeHolder').html('<iframe class="youtubeVideoForTryDemo" id="iframe" src="https://www.youtube.com/embed/weegWvlF0Ds" width="100%" height="450"></iframe>');
        }
      });

    }
  }

  genderCodedTabe(){
    this.lqr_Correctness = false;
    this.lqr_Readability = false;
    this.lqr_Consistency = false;
    this.lqr_Conciseness = false;
    this.lqr_FormalTone = false;
    this.lqr_InclusiveLanguage = false;
    this.lqr_CodeWords = false;
    this.lqr_GenderCode = true;
    this.status= false;
  }
  correctnessTabe(){
    this.lqr_Correctness = true;
    this.lqr_Readability = false;
    this.lqr_Consistency = false;
    this.lqr_Conciseness = false;
    this.lqr_FormalTone = false;
    this.lqr_InclusiveLanguage = false;
    this.lqr_CodeWords = false;
    this.lqr_GenderCode = false;
    this.status= false;
  }
  ReadabilityTabe(){
    this.lqr_Correctness = false;
    this.lqr_Readability = true;
    this.lqr_Consistency = false;
    this.lqr_Conciseness = false;
    this.lqr_FormalTone = false;
    this.lqr_InclusiveLanguage = false;
    this.lqr_CodeWords = false;
    this.lqr_GenderCode = false;
    this.status= false;
  }
  ConsistencyTabe(){
    this.lqr_Correctness = false;
    this.lqr_Readability = false;
    this.lqr_Consistency = true;
    this.lqr_Conciseness = false;
    this.lqr_FormalTone = false;
    this.lqr_InclusiveLanguage = false;
    this.lqr_CodeWords = false;
    this.lqr_GenderCode = false;
    this.status= false;
  }
  ConcisenessTabe(){
    this.lqr_Correctness = false;
    this.lqr_Readability = false;
    this.lqr_Consistency = false;
    this.lqr_Conciseness = true;
    this.lqr_FormalTone = false;
    this.lqr_InclusiveLanguage = false;
    this.lqr_CodeWords = false;
    this.lqr_GenderCode = false;
    this.status= false;
  }
  FormalToneTabe(){
    this.lqr_Correctness = false;
    this.lqr_Readability = false;
    this.lqr_Consistency = false;
    this.lqr_Conciseness = false;
    this.lqr_FormalTone = true;
    this.lqr_InclusiveLanguage = false;
    this.lqr_CodeWords = false;
    this.lqr_GenderCode = false;
    this.status= false;
  }
  InclusiveLanguageTabe(){
    this.lqr_Correctness = false;
    this.lqr_Readability = false;
    this.lqr_Consistency = false;
    this.lqr_Conciseness = false;
    this.lqr_FormalTone = false;
    this.lqr_InclusiveLanguage = true;
    this.lqr_CodeWords = false;
    this.lqr_GenderCode = false;
    this.status= false;
  }
  CodeWordsTabe(){
    this.lqr_Correctness = false;
    this.lqr_Readability = false;
    this.lqr_Consistency = false;
    this.lqr_Conciseness = false;
    this.lqr_FormalTone = false;
    this.lqr_InclusiveLanguage = false;
    this.lqr_CodeWords = true;
    this.lqr_GenderCode = false;
    this.status = !this.status;     
  }

  

}
